import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '../abstract-form-control';
import { BuildingAllocationDataDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-building-owner-select',
  templateUrl: './building-owner-select.component.html',
  styleUrl: './building-owner-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingOwnerSelectComponent),
      multi: true,
    },
  ],
})
export class BuildingOwnerSelectComponent extends AbstractFormControl<BuildingAllocationDataDto.OwnerEnum>{
  readonly BuildingOwner = BuildingAllocationDataDto.OwnerEnum;
}
